import Vue from 'vue';
import IColors from '../models/colors';
import IWorldDay, { IWorldHistory } from '../models/world';

interface State {
	countryId: string;
	summary: IWorldDay;
	histories: IWorldHistory;
	colors: IColors;
	datesWithData: Date[];
}
interface IModule {
	state: State;
	mutations: any;
	actions: any;
	getters: any;
	namespaced?: boolean;
}


const world: IModule = {
	namespaced: true,
	state: {
		countryId: '',
		summary: {
			date: new Date(),
			total: 0,
			totalDiff: 0,
			countries: [{
				id: 0,
				code: '',
				total: 0,
				totalDiff: 0,
				name: '',
				operators: [{
					id: 0,
					count: 0,
					diff: 0,
				}],
			}],
			operators: [{
				count: 0,
				diff: 0,
				id: 0,
			}],
			grades: [0],
		},
		histories: {
			countryHistories: [{
				countryId: 0,
				histories: [{
					x: new Date(),
					y: 0,
				}],
			}],
			totalHistories: [{
				x: new Date(),
				y: 0,
			}],
		},
		colors: {
			nodata: '#f8f8f8',
			default: '#8080ff',
			hover: '#0000b3',
			border: '#808080',
		},
		datesWithData: [new Date()],
	},
	mutations: {
		setCountryId(state: State, countryId: string) {
			state.countryId = countryId;
		},
		setSummary(state: State, summary: IWorldDay) {
			if (!summary.countries.find((v) => v.code === state.countryId)) {
				state.countryId = '';
			}
			state.summary = summary;
		},
		setHistories(state: State, histories: IWorldHistory) {
			state.histories = histories;
		},
		setColors(state: State, colors: IColors) {
			state.colors = colors;
			state.colors.border = state.colors.border.toLowerCase();
			state.colors.default = state.colors.default.toLowerCase();
			state.colors.hover = state.colors.hover.toLowerCase();
			state.colors.nodata = state.colors.nodata.toLowerCase();
		},
		setAllowedDates(state: State, dates: Date[]) {
			state.datesWithData = dates;
		},
	},
	actions: {
		updateCountryId(context, countryId: string) {
			context.commit('setCountryId', countryId);
		},
		updateSummary(context, summary: IWorldDay) {
			context.commit('setSummary', summary);
		},
		updateHistories(context, histories: IWorldHistory) {
			context.commit('setHistories', histories);
		},
		updateColors(context, colors: IColors) {
			context.commit('setColors', colors);
		},
		updateAllowedDates(context, dates: Date[]) {
			context.commit('setAllowedDates', dates);
		},
	},
	getters: {
		getCountryId: (state: State) => state.countryId,
		getSummary: (state: State) => state.summary,
		getCountry: (state: State) => {
			if (state.countryId === '') {
				return {
					name: 'Все страны',
					operators: state.summary.operators,
					total: state.summary.total,
					totalDiff: state.summary.totalDiff,
				};
			} else {
				return state.summary.countries.find((v) => v.code === state.countryId);
			}
		},
		getHistories: (state: State) => {
			if (state.countryId === '') {
				return state.histories.totalHistories;
			} else {
				const country = state.summary.countries.find((c) => c.code === state.countryId);
				if (country) {
					const histry = state.histories.countryHistories.find((v) => v.countryId === country.id);
					if (histry) {
						return histry.histories;
					}
				}
			}
			return state.histories.totalHistories;
		},
		getActiveCountries: (state: State) => state.summary.countries
			.filter((v) => v.total > 0 || v.totalDiff !== 0)
			.map((c) => c.code),
		getColors: (state: State) => state.colors,
		getTotalCount: (state: State) => state.summary.total,
		getTotalPrevCount: (state: State) => state.summary.totalDiff,
		getTotalOperators: (state: State) => state.summary.operators,
		getDataDate: (state: State) => state.summary.date,
		getAllowedDates: (state: State) => state.datesWithData,
	},
};

export default world;
